<template>
  <div>
    <div class="domain-panel-title">
      涉猎领域
    </div>
    <div class="domain-panel-desp">
      微信小程序、app原生开发、
      <br>
      Vue、react前端开发、官网开发
    </div>
    <div class="domain-panel-line"/>
    <div class="domain-panel-content">
      <DomainItem v-for="(domain, index) in domains" :key="index" :domain="domain"/>
    </div>
  </div>
</template>

<script>
  import DomainItem from './DomainItem'

  export default {
    name: 'DomainPanel',
    data () {
      return {
        domains: [
          {
            iconUrl: require('../assets/images/domain1.png'),
            bgUrl: require('../assets/images/domainBg1.png'),
            title: '微信小程序',
            desp: '无需安装、触手可及、用完即走，更贴近您的生活'
          },
          {
            iconUrl: require('../assets/images/domain2.png'),
            bgUrl: require('../assets/images/domainBg2.png'),
            title: 'APP原生开发',
            desp: '极致的流畅性、稳定性，让您的APP应用扬帆起航'
          },
          {
            iconUrl: require('../assets/images/domain3.png'),
            bgUrl: require('../assets/images/domainBg3.png'),
            title: 'Vue、React',
            desp: '当下最流行的前端开发框架，给予客户最好的用户体验'
          },
          {
            iconUrl: require('../assets/images/domain4.png'),
            bgUrl: require('../assets/images/domainBg4.png'),
            title: '官网设计开发',
            desp: '花更少的钱,做效果更好的网站 花一样的钱,做不一样的网站'
          }
        ]
      }
    },
    components: {DomainItem}
  }
</script>

<style scoped>
  .domain-panel-title {
    text-align: center;
    margin-top: 10.42vw;
    font-size: 3.125vw;
    margin-bottom: 0.8854vw;
    color: #1158E8;
    font-family: PingFangSC-Semibold;
  }

  .domain-panel-desp {
    font-family: PingFangSC-Regular;
    font-size: 1.042vw;
    color: #999999;
    text-align: center;
    line-height: 1.5625vw;
  }

  .domain-panel-line {
    width: 5.677vw;
    height: 0.3125vw;
    background-color: #1158E8;
    margin: 1.875vw auto 6.094vw auto;
  }

  .domain-panel-content {
    padding-left: 7.552vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/DomainPanel.vue